export const formatRoutePath = (path: string) => {
  return path.split(' ').join('-').toLowerCase();
};
